// The single hard-coded "featured petition" spotlighted by the UK surging-petition card
// (the PC Andrew Harper petition). See plan §Consumption.
export const FEATURED_PETITION_SLUG = 'petition-to-stop-the-early-release-from-jail-of-pc-andrew-harper-s-killers';

export const FEATURED_PETITION_URL = `/p/${FEATURED_PETITION_SLUG}`;
